import { BadgeStatus } from '@cas/components/data-display/badge-dot/BadgeDot';
import StatusCell from '@cas/components/data-display/status-cell/StatusCell';
import { VIType } from '@customer/store/apis/interactionsApi';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyCell } from '../../formatters/genericFormatters';

const getInteractionStatus = (interactionType: VIType): BadgeStatus => {
  switch (interactionType) {
    case VIType.CollisionAlarm:
    case VIType.TailgatingAlarm:
      return BadgeStatus.Danger;
    case VIType.CollisionAlert:
    case VIType.TailgatingAlert:
      return BadgeStatus.Warning;
    case VIType.CollisionAware:
    case VIType.TailgatingAware:
      return BadgeStatus.Caution;
    case VIType.Unknown:
    default:
      return BadgeStatus.Neutral;
  }
};

interface VehicleInteractionTypeRendererProps {
  value?: VIType;
  size?: 'small' | 'medium' | 'large';
}

export function VehicleInteractionTypeRenderer({
  value,
  size,
}: VehicleInteractionTypeRendererProps): ReactElement | string {
  const { t } = useTranslation();

  if (typeof value !== 'undefined') {
    return (
      <StatusCell label={t(`vi.name.${value}`)} status={getInteractionStatus(value)} size={size} />
    );
  }

  return EmptyCell;
}

export default VehicleInteractionTypeRenderer;
